import { transport } from 'config/transport';

export function callApiRestoreStudent(classId, studentId) {
    return transport.put(`/mamnon/classes/${classId}/students/${studentId}/restore`);
}
